/**
 * Вычисление периода текущего дежурства (05:00 UTC → 05:00 UTC)
 */
export const getShiftPeriod = (now = new Date()): { start: Date; end: Date; label: string } => {
  const today5Utc = new Date(
    Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), 5, 0, 0)
  );
  const tomorrow5Utc = new Date(today5Utc);
  tomorrow5Utc.setUTCDate(tomorrow5Utc.getUTCDate() + 1);

  let start: Date;
  let end: Date;

  if (now < today5Utc) {
    const yesterday5Utc = new Date(today5Utc);
    yesterday5Utc.setUTCDate(yesterday5Utc.getUTCDate() - 1);
    start = yesterday5Utc;
    end = today5Utc;
  } else {
    start = today5Utc;
    end = tomorrow5Utc;
  }

  const pad2 = (n: number) => String(n).padStart(2, '0');
  const label = `${pad2(start.getUTCDate())}.${pad2(start.getUTCMonth() + 1)}.${start.getUTCFullYear()} 05:00 UTC → ${pad2(end.getUTCDate())}.${pad2(end.getUTCMonth() + 1)}.${end.getUTCFullYear()} 05:00 UTC`;

  return { start, end, label };
};
